<template>
    <AppHead title="Passwort zurücksetzen" />
    <div class="lg:px-64">
        <PageTitle>Passwort zurücksetzen</PageTitle>
        <ValidationErrors class="mb-4" />
        <form @submit.prevent="submit">
            <div>
                <FormLabel for="email" value="E-Mail" />
                <FormInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
            </div>
            <div class="mt-4">
                <FormLabel for="password" value="Passwort" />
                <FormInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
            </div>
            <div class="mt-4">
                <FormLabel for="password_confirmation" value="Passwort bestätigen" />
                <FormInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
            </div>
            <div class="flex items-center justify-end mt-4">
                <FormButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Passwort zurücksetzen
                </FormButton>
            </div>
        </form>
    </div>
</template>

<script setup>
import { useForm } from "@inertiajs/vue3";
import AppHead from '@/Shared/Head'
import PageTitle from '@/Shared/Page/Title'
import ValidationErrors from '@/Shared/Form/ValidationErrors'
import FormLabel from '@/Shared/Form/Label'
import FormInput from '@/Shared/Form/Input'
import FormButton from '@/Shared/Form/Button'

const props = defineProps({
    email: String,
    token: String,
});
const form = useForm({
    token: props.token,
    email: props.email,
    password: '',
    password_confirmation: '',
});
const submit = () => {
    form.post(route('manager.password.update'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>
